export default __webpack_public_path__ + "static/media/logo_vinous.51059d9d.png";